import { Controller } from '@hotwired/stimulus';
import application from '~/stimulus_application';

class FlashController extends Controller {
  static values = {
    delay: { type: Number, default: 4000 },
  };

  declare delayValue: number;

  private timeout: ReturnType<typeof setTimeout> | null = null;
  private remaining: number = 0;
  private startTime: number = 0;

  connect(): void {
    this.remaining = this.delayValue;
    this.startTimer();
  }

  disconnect(): void {
    this.clearTimer();
  }

  dismiss(): void {
    this.clearTimer();
    const el = this.element as HTMLElement;
    el.style.transition = 'opacity 200ms ease-out, transform 200ms ease-out';
    el.style.opacity = '0';
    el.style.transform = 'translateX(0.5rem)';
    setTimeout(() => el.remove(), 200);
  }

  pause(): void {
    if (this.timeout !== null) {
      this.clearTimer();
      this.remaining -= Date.now() - this.startTime;
    }
  }

  resume(): void {
    if (this.timeout === null && this.remaining > 0) {
      this.startTimer();
    }
  }

  private startTimer(): void {
    this.startTime = Date.now();
    this.timeout = setTimeout(() => this.dismiss(), this.remaining);
  }

  private clearTimer(): void {
    if (this.timeout !== null) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  }
}

application.register('ui--flash', FlashController);
